export default {"src":"/_next/static/media/integrations.6467aee3.svg","height":729,"width":966,"blurWidth":0,"blurHeight":0};